/**
 * Google AdSense (display ads on site).
 *
 * Set REACT_APP_ADSENSE_CLIENT=ca-pub-XXXXXXXXXXXXXXXX in Render / .env.production
 * after your site is approved at https://adsense.google.com
 *
 * Optional slot IDs from AdSense → Ads → By ad unit:
 *   REACT_APP_ADSENSE_SLOT_HOME — homepage banner
 *   REACT_APP_ADSENSE_SLOT_MAP  — map standings sidebar
 *   REACT_APP_ADSENSE_SLOT_STATS — Ask the Map page
 *
 * If only CLIENT is set, Auto ads (configured in AdSense console) can still serve.
 * Update public/ads.txt with your publisher ID before going live.
 */

export type AdPlacement = 'home' | 'map' | 'stats';

const CLIENT = (process.env.REACT_APP_ADSENSE_CLIENT || '').trim();

const SLOTS: Record<AdPlacement, string> = {
    home: (process.env.REACT_APP_ADSENSE_SLOT_HOME || '').trim(),
    map: (process.env.REACT_APP_ADSENSE_SLOT_MAP || '').trim(),
    stats: (process.env.REACT_APP_ADSENSE_SLOT_STATS || '').trim(),
};

/** True when a valid ca-pub-… client id is configured at build time. */
export function isAdSenseEnabled(): boolean {
    return /^ca-pub-\d+$/.test(CLIENT);
}

export function getAdSenseClient(): string | null {
    return isAdSenseEnabled() ? CLIENT : null;
}

export function getAdSenseSlot(placement: AdPlacement): string | null {
    const slot = SLOTS[placement];
    return slot && /^\d+$/.test(slot) ? slot : null;
}

/** Manual ad unit vs script-only (Auto ads in AdSense dashboard). */
export function hasManualAdUnit(placement: AdPlacement): boolean {
    return isAdSenseEnabled() && !!getAdSenseSlot(placement);
}
